import { Vue, Component, Prop, Watch, Inject } from 'vue-property-decorator';
import uuid4 from 'uuid';
import style from './style.vue';
import { Functions } from '@/library/utils/functions';
import { globalElement } from '@/library/utils/globalElement';
import AdContentItem from '@/views/components/shopDisplaySketchMap/displayEdit/adContentItem';

@Component({
  mixins: [style],
  components: { AdContentItem }
})
export default class AdContent extends Vue {
  @Prop()
    value: SiteAdConfig[];

  @Inject()
    openCoupon: Function;


  @Prop({ default: 300 })
    pSize: number;

  @Prop({ default: () => [] })
    attrButeList: ItemArray;

  @Prop()
    fromPage: number;

  imgTpConfig = `${Functions.ipsHostUrlApi()}/pic/upload/withOut/key`;

  data: SiteAdConfig[] = [];

  siteId = 0;
  uuid = uuid4();

  @Prop({ default: false })
    classAd: boolean;

  @Watch('value', { immediate: true, deep: true })
  watchValue(n, o) {
    if (JSON.stringify(n) !== JSON.stringify(o)) {
      console.log('adContent', n)
      this.data = n;
    }
  }

  @Watch('data', { deep: true })
  watchData(n) {
    this.$emit('input', this.data);
  }

  created() {
    this.siteId = +globalElement.Vm.$route.params.siteId;
  }


  uploadSuccess(res: HttpAPIRetItem<any>, i) {
    this.getImgInfo(res).then((img: any) => {
      this.data[i].advPic = res.content;
      this.data[i].width = img.width;
      this.data[i].height = img.height;
    });
  }

  getImgInfo(info) {
    return new Promise((resolve) => {
      const img = new Image();
      img.src = info.content;
      const arr = { width: 0, height: 0 };
      img.onload = function() {
        arr.width = img.width;
        arr.height = img.height;
        resolve(arr);
      };
    });
  }

  // 添加一个广告
  addAd() {
    if (this.classAd) {
      if (this.data.length === 3) {
        this.$message.error('分类广告图片不能超过三张！');
        return;
      }
      this.data.push({
        advPic: '',
        advTitle: '',
        advLinkType: 1,
        linkList: [],
        width: 0,
        height: 0,
      });
      return;
    }
    this.data.push({
      advPic: '',
      advTitle: '',
      advLinkType: 1,
      linkList: [],
      width: 0,
      height: 0,
      startOfTime: '',
      endOfTime: '',
    });

  }

  handleDel(i) {
    this.$confirm('确定删除该广告?', { type: 'warning' }).then((result) => {
      if (result === 'confirm') {
        this.data.splice(i, 1);
      }
    });
  }



  render(h) {
    return (
      <div class="site-ad">
        <draggable scroll={true} v-model={this.data} draggable={'.ad-content-item'} preventOnFilter={false} filter={'.ad-title,.datepicker'} scroll-sensitivity={150} force-fallback={true}>
          {this.data.map((v, i) => {
            return (
              <AdContentItem key={this.uuid + i} index={i} value={v} fromPage={this.fromPage}
                             attrButeList={this.attrButeList} pSize={this.pSize} classAd={this.classAd} onDelete={()=>this.handleDel(i)} onInput={(e)=>{ this.data[i]=e }}
              />
            );
          })}
        </draggable>
        <div class="add-ad scopeSpan" onClick={this.addAd.bind(this)}>
          +添加图片
        </div>
        {/* <p class="tip blockTip">注：建议图片分辨率为750px*{this.pSize}px，大小不超过2M，支持jpg、gif、png格式</p> */}
      </div>
    );
  }
}
